<script setup lang="ts">
import type { PaymentProviderType } from "@innoclouds/api";
import KsoOrderCreated from "../ksoOrderCreated/KsoOrderCreated.vue";
import KsoOrderLoader from "../ksoOrderLoader/KsoOrderLoader.vue";
import KsoPaymentMethods from "../ksoPaymentMethods/KsoPaymentMethods.vue";
import type { KsoStage } from "../stages";

interface Props {
	stage: KsoStage;
	immersive: boolean;
	orderReady: boolean;
	phrases: string[] | null;
	phraseInterval: number | null;
	discount: number;
	bonuses: number;
	maxBonuses: number;
	total: number;
	deliveryCost: number | null;
	providers: PaymentProviderType[];
	currencySymbol: string | null;
	bonusSign: string;
	allowDecimalBonuses: boolean;
	bonusesOpen: boolean;
	decoration?: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
	"cancel-creating": [];
	"apply-bonuses": [value: number];
	"close-bonuses": [];
	"select-provider": [provider: PaymentProviderType];
	"close-methods": [];
}>();
</script>

<template>
	<div class="kso_sheet_stack">
		<Transition name="kso_stage">
			<KsoOrderLoader
				v-if="props.stage === 'creating'"
				key="creating"
				:immersive="props.immersive"
				:active="props.stage === 'creating'"
				:completed="props.orderReady"
				:backend-phrases="props.phrases"
				:phrase-interval="props.phraseInterval"
				:decoration="props.decoration"
				@cancel="emit('cancel-creating')"
			/>
			<KsoOrderCreated
				v-else-if="props.stage === 'created'"
				key="created"
				:immersive="props.immersive"
				:discount="props.discount"
				:bonuses="props.bonuses"
				:max-bonuses="props.maxBonuses"
				:total="props.total"
				:delivery-cost="props.deliveryCost"
				:currency-symbol="props.currencySymbol"
				:bonus-sign="props.bonusSign"
				:allow-decimal-bonuses="props.allowDecimalBonuses"
				:bonuses-open="props.bonusesOpen"
				:decoration="props.decoration"
				@apply-bonuses="(value) => emit('apply-bonuses', value)"
				@close-bonuses="emit('close-bonuses')"
			/>
			<KsoPaymentMethods
				v-else-if="props.stage === 'methods'"
				key="methods"
				:providers="props.providers"
				:total="props.total"
				:currency-symbol="props.currencySymbol"
				:decoration="props.decoration"
				@select="(provider) => emit('select-provider', provider)"
				@back="emit('close-methods')"
			/>
		</Transition>
	</div>
</template>
